import script from "./uses.vue?vue&type=script&setup=true&lang=js"
export * from "./uses.vue?vue&type=script&setup=true&lang=js"

import "./uses.vue?vue&type=style&index=0&id=28968842&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28968842"]])

export default __exports__